import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { EncryptionService } from './encryption/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  // BehaviorSubject to track the authentication status
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(this.hasToken());

  // Variable to store the inactivity timeout ID
  private inactivityTimeout: any;

  constructor(private router: Router, private encryptionService: EncryptionService) {
    // Set up user activity listeners to reset the inactivity timer
    // this.setupUserActivity();
    // Initialize the inactivity timer
    // this.resetUserActivity();
     // Listen for changes in local storage
     window.addEventListener('storage', (event) => {
      if (event.key === 'uidToken' && !event.newValue) {
        this.isAuthenticatedSubject.next(false);
        this.router.navigate(['']);
      }
    });
  }

  // Check if there is a token in local storage
  private hasToken(): boolean {
    return !!localStorage.getItem('uidToken');
  }

  // Getter for the authentication status observable
  get isAuthenticated() {
    return this.isAuthenticatedSubject.asObservable();
  }

  // Method to handle user login
  login(token: string, user_type: string, employee_name: string, user_id: string,department_id: string,department : string,factory_department:string,factory_department_name:string): void {
    // Store all relevent data in local storage
    const encryptedToken = this.encryptionService.encrypt(token);
    localStorage.setItem('token', "1234");
    localStorage.setItem('userType', 'admin');
    localStorage.setItem('userTypecon', user_type);
    localStorage.setItem('EmployeeName', employee_name);
    localStorage.setItem('admin_id', user_id);
    localStorage.setItem('uidToken', encryptedToken);
    localStorage.setItem('department_id', department_id);
    localStorage.setItem('department', department);
    localStorage.setItem('headDep_id', factory_department);
    localStorage.setItem('headDep_name', factory_department_name);
    // Update the authentication status
    this.isAuthenticatedSubject.next(true);
    // Reset the inactivity timer
    // this.resetUserActivity();
  }

  // Method to handle user logout
  logout(): void {
    // Remove all relevant items from local storage
    localStorage.clear()
 
    // Update the authentication status
    this.isAuthenticatedSubject.next(false);
    // Navigate to the root route
    this.router.navigate(['']);
  }

  // Method to reset the inactivity timer
  resetUserActivity(): void {
    // Clear any existing timeout
    clearTimeout(this.inactivityTimeout);
    // Set a new timeout to log out the user after inactivity
    this.inactivityTimeout = setTimeout(() => {
      this.logout();
    }, 60000);
  }

  // Method to set up event listeners for user activity
  private setupUserActivity(): void {
    // Reset the inactivity timer on mouse movement
    window.addEventListener('mousemove', () => {
      this.resetUserActivity();
    });
    // Reset the inactivity timer on scroll
    window.addEventListener('scroll', () => {
      this.resetUserActivity();
    });
    // Reset the inactivity timer on key press
    window.addEventListener('keydown', () => {
      this.resetUserActivity();
    });
    // Reset the inactivity timer on mouse click
    window.addEventListener('click', () => {
      this.resetUserActivity();
    });
  }
}